import { TypeGuardError } from 'src/core/utils/switchGuard';

import { type ApprovalWorkflowBranchExport } from './approvalWorkflowExportTypes';
import { type DimensionName } from '../../approvalWorkflow';

export const getDimensionNameKey = (dimension: DimensionName): string => {
  switch (dimension.type) {
    case 'customField':
      return `customField-${dimension.name}`;
    case 'spendType':
    case 'costCenter':
    case 'team':
    case 'expenseCategory':
      return dimension.type;
    default:
      throw new TypeGuardError(dimension, 'Unknown dimension type');
  }
};

export const collectDimensions = (
  branch?: ApprovalWorkflowBranchExport,
  dimensions: Map<string, DimensionName> = new Map(),
) => {
  if (branch) {
    dimensions.set(getDimensionNameKey(branch.dimension), branch.dimension);
    branch.nodes.forEach((node) => {
      collectDimensions(node.branch, dimensions);
    });
  }
  return dimensions;
};
